<template>
    <v-layout align-center justify-center>
        <v-flex xs12 sm8 md6 lg4>
            <v-card class="elevation-12">
                <v-form @submit.prevent="handlePasswordReset">
                    <v-card-text>
                        <h1>Reset Password</h1>
                        <p>Please use the form below to reset your password.</p>
                        <p class="subheading warning--text">All fields are required</p>

                        <v-text-field
                            box
                            v-model.trim="userInfo.password"
                            required
                            :rules="passwordRules"
                            label="Password"
                            type="password"
                        ></v-text-field>

                        <v-text-field
                            box
                            v-model.trim="userInfo.passwordConfirm"
                            required
                            :rules="passwordConfirmationRules"
                            label="Confirm Password"
                            type="password"
                        ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="#001e60" dark type="submit">Reset Password</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import FormRules from "@/helpers/form-rules";

export default {
    data() {
        return {
            userInfo: {
                email: null,
                password: null,
                passwordConfirm: null,
            },
            passwordRules: FormRules.password,
            passwordConfirmationRules: [
                v => !!v || "Please confirm your password",
                v => v === this.userInfo.password || "Passwords do not match",
            ],
        };
    },

    methods: {
        handlePasswordReset() {
            const payload = {
                email: this.userInfo.email,
                password: this.userInfo.password,
                password_confirmation: this.userInfo.passwordConfirm,
                token: this.$route.params.token,
            };

            this.$store.dispatch("resetPassword", payload)
                .then(() => {
                    this.$router.push({ name: "login" });
                })
                .catch(err => {
                    // do nothing since error handling happens in the store
                });
        },
    },
};
</script>